import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { PreparationInsight } from './types';
import { getBaseUrl, getDateRangeForApiCall } from '../utils';

export const getPreparationInsightForEntity = (entityType: EntityType, entityId: string, interval: Interval) => {
  return merchantGatewayApi
    .get<PreparationInsight>(`${getBaseUrl(entityType, entityId)}/avg-preparation-time`, {
      params: getDateRangeForApiCall(interval),
    })
    .then(response => response.data);
};
